import React from 'react';
import Navigation from '../components/Navigation';

const Terms = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="terms-page">
      <Navigation />
      
      {/* Header */}
      <div className="bg-gray-50 border-b border-gray-100 pt-20">
        <div className="max-w-3xl mx-auto px-6 py-12">
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900">Terms of Use</h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-6 py-12">
        <div className="prose prose-gray max-w-none">
          <p className="text-gray-600 leading-relaxed mb-6">
            The content on this website is provided for general informational purposes only.
          </p>
          
          <p className="text-gray-600 leading-relaxed mb-6">
            Xerobrain Labs does not make any guarantees about the accuracy or completeness of information on this site.
          </p>
          
          <p className="text-gray-600 leading-relaxed mb-6">
            Nothing on this website constitutes financial, legal, or professional advice.
          </p>
          
          <p className="text-gray-600 leading-relaxed">
            By using this website, you agree that Xerobrain Labs is not responsible for any loss or damages arising from its use.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Terms;
